import { QueryClient } from '@tanstack/react-query';

/**
 * Single app-wide QueryClient instance. Lives in its own module (rather than
 * being created inline in main.tsx) so `client.ts`'s 401 interceptor can
 * import and clear it without a circular import between the two.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnWindowFocus: false,
    },
  },
});
